// Swatch hover (collection grid) + thumbnail scroll-to-selected (PDP) + PDP polish
(function () {
  'use strict';

  // ============================================================
  // Part 1: Collection-grid swatch hover-to-swap
  // ============================================================
  function findCard(el) {
    return el.closest('.js-product-listing') || el.closest('[data-product-id]');
  }
  function getMainImg(card) { return card && card.querySelector('.js-product-image img'); }
  function saveOriginal(img) {
    if (!img.dataset.origSrc) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
    }
  }
  function applyImg(img, src) {
    if (!img || !src) return;
    saveOriginal(img);
    img.removeAttribute('srcset');
    img.src = src;
  }
  function restoreImg(img) {
    if (!img || !img.dataset.origSrc) return;
    img.src = img.dataset.origSrc;
    if (img.dataset.origSrcset) img.srcset = img.dataset.origSrcset;
    else img.removeAttribute('srcset');
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var sw = e.target.closest('li.color[data-variant-image]');
    if (!sw) return;
    var card = findCard(sw); if (!card) return;
    var img = getMainImg(card); if (!img) return;
    var src = sw.getAttribute('data-variant-image'); if (!src) return;
    applyImg(img, src);
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target || !e.target.closest) return;
    var sw = e.target.closest('li.color[data-variant-image]');
    if (!sw) return;
    var group = sw.closest('.product--grid__swatches');
    if (group && e.relatedTarget && group.contains(e.relatedTarget)) return;
    var card = findCard(sw); if (!card) return;
    restoreImg(getMainImg(card));
  });

  // ============================================================
  // Part 2: PDP thumbnail scroll-to-selected
  // ============================================================
  function scrollActiveThumbIntoView(root) {
    var active = (root || document).querySelector('.js-thumb-item.is-nav-selected');
    if (!active) return;
    if (typeof active.scrollIntoView === 'function') {
      active.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }
  function initThumbObserver() {
    var thumbWrapper = document.querySelector('.js-thumb-wrapper');
    if (!thumbWrapper) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.attributeName === 'class') {
          var el = m.target;
          if (el.classList && el.classList.contains('is-nav-selected')) {
            scrollActiveThumbIntoView(thumbWrapper); return;
          }
        }
      }
    });
    thumbWrapper.querySelectorAll('.js-thumb-item').forEach(function (t) {
      observer.observe(t, { attributes: true, attributeFilter: ['class'] });
    });
    setTimeout(function () { scrollActiveThumbIntoView(thumbWrapper); }, 300);
  }

  // ============================================================
  // Part 3: PDP — merge price into Add-to-cart button text
  //   Reads #product-price on load and on variant change, updates
  //   #addToCart value to "Add to cart · $XXX.XX"
  // ============================================================
  function getCurrentPriceText() {
    var el = document.querySelector('#product-price .price-item--sale, #product-price .price-item--regular, #product-price .price-item');
    if (!el) return '';
    return el.textContent.trim();
  }
  function updateCartButton() {
    var btn = document.querySelector('#addToCart');
    if (!btn) return;
    var base = btn.dataset.baseLabel;
    if (!base) {
      base = btn.value || 'Add to cart';
      btn.dataset.baseLabel = base;
    }
    var price = getCurrentPriceText();
    if (price) {
      btn.value = base + ' · ' + price;
    } else {
      btn.value = base;
    }
  }
  function initCartButtonPrice() {
    var priceEl = document.querySelector('#product-price');
    if (!priceEl) return;
    updateCartButton();
    var observer = new MutationObserver(updateCartButton);
    observer.observe(priceEl, { childList: true, subtree: true, characterData: true });
  }

  // ============================================================
  // Part 4: PDP — breadcrumb from product's primary collection
  //   Inserts breadcrumb <nav> before the product title. Tries to
  //   use the first collection found in the page (link tag metadata),
  //   otherwise falls back to "Shop · <Product Type>".
  // ============================================================
  function insertBreadcrumb() {
    if (document.querySelector('.kd-breadcrumb')) return;
    var title = document.querySelector('.product__section-title.product-title');
    if (!title) return;
    // Try to get the type/collection from dataset on body or meta
    var parts = [];
    var typeMeta = document.querySelector('meta[property="product:category"]');
    // Prefer "Shop" as root
    parts.push('<a href="/collections/all">Shop</a>');
    var productType = document.body && document.body.dataset ? document.body.dataset.productType : '';
    if (productType) parts.push('<span class="kd-sep">/</span>' + productType);
    var bc = document.createElement('nav');
    bc.className = 'kd-breadcrumb';
    bc.innerHTML = parts.join('');
    title.parentNode.insertBefore(bc, title);
  }

  function initPDP() {
    if (!document.body.classList.contains('template-product')) return;
    initThumbObserver();
    initCartButtonPrice();
    insertBreadcrumb();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPDP);
  } else {
    initPDP();
  }
})();
